import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BarcodeGeneratorSummary } from '~/models/modules/barcodeGenerator';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';

@Component({
    selector: 'app-stocks-barcode-generators-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksBarcodeGeneratorsUpsertComponent {
  _active: boolean;
  _theme: string;
  _form: FormGroup;
  _invalidForm: boolean;
  _model: BarcodeGeneratorSummary;

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _fb: FormBuilder,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    @Inject(PORTAL_DATA) public data: any
  ) {
    if (data) {
      this._active = true;
      this._model = data.model;
    }

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
  }

  _onSave(e: any) {
    this.submit();
  }

  _onEditForm() { }

  _onCancel() {
    this._closeForm();
  }

  _closeForm() {
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('barcodeGenerators');
    this.ngOnDestroy();
  }

  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  ngOnInit() {
    this._initForm();
  }

  private _initForm() {
    this._form = this._fb.group({
      id: [this._model ? this._model.id : null],
      barcodefield: [this._model ? this._model.barcodeField : ''],
      prefix: [this._model ? this._model.prefix : ''],
      length: [this._model ? this._model.length : null, Validators.required],
      incrementingnumber: [this._model ? this._model.incrementingNumber : null],
      countersetpoint: [this._model ? this._model.countersetPoint : null],
      suffix: [this._model ? this._model.suffix : ''],
      isenabled: [this._model ? this._model.isEnabled : false]
    });
  }

  private submit = () => {
    if (this._form.invalid) {
      this._invalidForm = true;
    } else {
      this._invalidForm = false;
      const model = this._form.value;
      if (this._model) {
        this._barcodeGeneratorsService
          .updateBarcodeGenerator(this._model.id, model)
          
          .subscribe((response:any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
            }
            this._closeForm();
          });
      }
    }
  }
}
